import { createLogger } from 'redux-logger';
import Redux from 'redux';

export const logger: Redux.Middleware = createLogger({
  predicate: () => process.env.NODE_ENV === 'development',
  collapsed: true,
  logErrors: true,
  diff: true,
});
